export default "__VITE_ASSET__D6lI3PmA__"